import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import { hideConfirmationModal } from './confirmationModalReducer';
import { SalvConfirmationModal } from '@salvapp/ui-components';

export const ConfirmationModal = () => {
  const dispatch = useDispatch();
  const confirmationModalState = useSelector((state: AppState) => state.confirmationModal);

  return (
    <SalvConfirmationModal
      {...confirmationModalState}
      show={confirmationModalState.isOpen}
      onHide={() => {
        dispatch(hideConfirmationModal());
      }}
      onCancel={() => {
        confirmationModalState.onCancel?.();
      }}
    />
  );
};

export default ConfirmationModal;
